<template>
    <el-tabs v-model="activeTab" class="demo-tabs" @tab-change="handleTabChange">
        <!-- 账户兑换券管理 -->
        <el-tab-pane label="账户兑换券管理" :name="'manage'">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="券码：">
                    <el-input
                        v-model="searchForm.code"
                        placeholder="请输入券码"
                        style="width: 120px"
                    ></el-input>
                </el-form-item>
                <el-form-item label="所属手机号：">
                    <el-input
                        v-model="searchForm.userPhone"
                        placeholder="请输入手机号"
                        style="width: 120px"
                    ></el-input>
                </el-form-item>
                <el-form-item label="兑换券类型：">
                    <el-select
                        v-model="searchForm.type"
                        placeholder="全部"
                        style="width: 160px"
                    >
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="item in couponTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="创建时间：">
                    <el-date-picker
                        v-model="searchForm.dateRange"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始时间"
                        end-placeholder="截止时间"
                        style="width: 380px"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="searchCoupon">搜索</el-button>
                    <el-button @click="resetSearch">刷新</el-button>
                </el-form-item>
            </el-form>

            <!-- 操作按钮 -->
            <div style="margin: 15px 0; display: flex; align-items: center;">
                <el-button type="primary" icon="Plus" @click="openAddCouponDialog">新增兑换券</el-button>
                <el-button type="success" icon="Download" @click="downloadTemplate">下载模版</el-button>
                <el-upload
                    accept=".xlsx, .xls"
                    action=""
                    :http-request="importCoupon"
                    :limit="1"
                    :show-file-list="false"
                    style="display: inline-block; margin-left: 12px;"
                >
                    <el-button type="warning" icon="Upload">批量导入</el-button>
                </el-upload>
            </div>

            <el-table 
                class="table_wrapper" 
                :data="couponList" 
                :header-cell-style="{'text-align':'left'}" 
                :cell-style="{'text-align':'left'}"
            >
                <el-table-column label="券码" min-width="120" show-overflow-tooltip>
                    <template #default="scope">
                        <span>{{ scope.row.code }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="所属手机号" min-width="120">
                    <template #default="scope">
                        <span>{{ scope.row.userPhone || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="兑换券类型" min-width="150">
                    <template #default="scope">
                        <span>{{ filterCouponType(scope.row.type) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" min-width="180">
                    <template #default="scope">
                        <span>{{ scope.row.createTime }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="交易订单编号" min-width="180" show-overflow-tooltip>
                    <template #default="scope">
                        <span>{{ scope.row.transactionId || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="入账时间" min-width="180">
                    <template #default="scope">
                        <span>{{ scope.row.receiveTime || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="到期时间" min-width="180">
                    <template #default="scope">
                        <span>{{ scope.row.expireTime || '-' }}</span>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <Pagination
                v-model:current-page="manageCurrentPage"
                v-model:page-size="managePageSize"
                :total="manageTotal"
                @size-change="handleManageSizeChange"
                @current-change="handleManageCurrentChange"
            />
        </el-tab-pane>

        <!-- 兑换券统计 -->
        <el-tab-pane label="兑换券统计" :name="'statistics'">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="兑换券类型：">
                    <el-select
                        v-model="statsForm.type"
                        placeholder="全部"
                        style="width: 150px"
                    >
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="item in couponTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item style="margin-left: auto;">
                    <el-button type="primary" @click="searchStats">搜索</el-button>
                    <el-button @click="resetStats">刷新</el-button>
                </el-form-item>
            </el-form>

            <el-table 
                class="table_wrapper" 
                :data="statsList" 
                :header-cell-style="{'text-align':'left'}" 
                :cell-style="{'text-align':'left'}"
            >
                <el-table-column label="兑换券类型" min-width="200">
                    <template #default="scope">
                        <span>{{ filterCouponType(scope.row.type) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="已发数量" min-width="150">
                    <template #default="scope">
                        <span>{{ scope.row.issuedCount }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="库存余量" min-width="150">
                    <template #default="scope">
                        <span>{{ scope.row.unissuedCount }}</span>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <Pagination
                v-model:current-page="statsCurrentPage"
                v-model:page-size="statsPageSize"
                :total="statsTotal"
                @size-change="handleStatsSizeChange"
                @current-change="handleStatsCurrentChange"
            />
        </el-tab-pane>
    </el-tabs>

    <!-- 新增兑换券弹窗 -->
    <el-dialog
        title="新增兑换券"
        v-model="addDialogVisible"
        width="600px"
        :close-on-click-modal="false"
    >
        <el-form :model="addForm" label-width="120px">
            <el-form-item label="兑换券类型：" required>
                <el-select
                    v-model="addForm.type"
                    placeholder="请选择"
                    style="width: 300px"
                >
                    <el-option v-for="item in couponTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="券码：" required>
                <el-input
                    type="textarea"
                    v-model="addForm.code"
                    placeholder="请输入券码 0/500"
                    maxlength="500"
                    show-word-limit
                    :rows="8"
                    style="width: 450px;"
                ></el-input>
            </el-form-item>
        </el-form>
        <template #footer>
            <el-button @click="closeAddCouponDialog">返回</el-button>
            <el-button type="primary" @click="saveCoupon">保存</el-button>
        </template>
    </el-dialog>
</template>

<script>
import { ElMessage } from 'element-plus';
import { required } from '@/utils/validators';
export default {
    name:'ExchangeCoupon',
    data() {
        return {
            activeTab: 'manage',
            //3-美式咖啡兑换券 4-冰美式咖啡兑换券 5-拿铁兑换券 6-卡布奇诺兑换券 7-摩卡兑换券 8-无糖巧克力兑换券 9-无糖巧克力牛奶兑换券 10-热牛奶兑换券
            couponTypes: [
                { label: '美式咖啡兑换券', value: 3 },
                { label: '冰美式咖啡兑换券', value: 4 },
                { label: '拿铁兑换券', value: 5 },
                { label: '卡布奇诺兑换券', value: 6 },
                { label: '摩卡兑换券', value: 7 },
                { label: '无糖巧克力兑换券', value: 8 },
                { label: '无糖巧克力牛奶兑换券', value: 9 },
                { label: '热牛奶兑换券', value: 10 }
            ],
            // 管理页面搜索表单
            searchForm: {
                code: '',
                userPhone: '',
                type: '',
                dateRange: []
            },
            // 统计页面搜索表单
            statsForm: {
                type: ''
            },
            // 管理页面分页
            manageCurrentPage: 1,
            managePageSize: 10,
            manageTotal: 0,
            // 统计页面分页
            statsCurrentPage: 1,
            statsPageSize: 10,
            statsTotal: 0,
            // 数据列表
            couponList: [],
            statsList: [],
            // 新增兑换券弹窗
            addDialogVisible: false,
            addForm: {
                type: '',
                code: ''
            }
        };
    },
    mounted() {
        this.getCouponList();
    },
    methods: {
        handleTabChange(tab) {
            // console.log('tab---', tab);
            if (tab === 'statistics') {
                this.getStatsList();
            }else{
                this.getCouponList();
            }
        },
        // 打开新增兑换券弹窗
        openAddCouponDialog() {
            this.addForm = {
                type: '',
                code: ''
            };
            this.addDialogVisible = true;
        },
        // 关闭新增兑换券弹窗
        closeAddCouponDialog() {
            this.addDialogVisible = false;
        },
        // 下载模板
        downloadTemplate() {
            let that = this;
            that.$axios.post("/gateway/template/3", {}, {responseType: 'blob'}).then(result => {
                // 处理下载
            });
        },
        // 批量导入兑换券
        importCoupon(file) {
            const formData = new FormData();
            formData.append('file', file.file);

            let that = this;
            this.$axios.post(that.$store.state.platformApi + "exchange/coupon/import", formData, {headers: {'Content-Type': 'multipart/form-data'}}).then(response => {
                that.getCouponList();
                ElMessage({
                    message: '导入成功',
                    type: 'success'
                });
            });
        },
        // 保存新增兑换券
        saveCoupon() {
            let that = this;
            if (!that.addForm.type) {
                ElMessage({
                    message: '请选择兑换券类型',
                    type: 'warning'
                });
                return;
            }
            if (!that.addForm.code) {
                ElMessage({
                    message: '请输入券码',
                    type: 'warning'
                });
                return;
            }
            //去除空格，按逗号（兼容中英文逗号）分隔
            let codeArr = that.addForm.code.split(/[,]/);
            let param = {
                type: that.addForm.type,
                codes: codeArr
            };
            // 过滤空值
            param.codes = param.codes.filter(code => code.trim() !== '');
            // console.log('param---', param);
            that.$axios.post(that.$store.state.platformApi + "exchange/coupon/add", JSON.stringify(param)).then(result => {
                if (result.code == 200) {
                    ElMessage({
                        message: '新增成功',
                        type: 'success'
                    });
                    that.addDialogVisible = false;
                    that.getCouponList();
                }
            });
        },
        // 搜索兑换券
        searchCoupon() {
            this.manageCurrentPage = 1;
            this.getCouponList();
        },
        // 重置搜索
        resetSearch() {
                this.searchForm = {
                    code: '',
                    userPhone: '',
                    type: '',
                    dateRange: []
                };
                this.manageCurrentPage = 1;
                this.getCouponList();
            },
        // 搜索统计
        searchStats() {
            this.statsCurrentPage = 1;
            this.getStatsList();
        },
        // 重置统计搜索
        resetStats() {
                this.statsForm = {
                    type: ''
                };
                this.statsCurrentPage = 1;
                this.getStatsList();
            },
        // 获取兑换券列表
        getCouponList() {
            let that = this;
            let param = {
                page: that.manageCurrentPage,
                pageSize: that.managePageSize
            };
            
            // 只在有值时添加参数
            if (that.searchForm.code) {
                param.code = that.searchForm.code;
            }
            if (that.searchForm.userPhone) {
                param.userPhone = that.searchForm.userPhone;
            }
            if (that.searchForm.type) {
                param.type = that.searchForm.type;
            }
            // 日期范围有值时才添加
            if (that.searchForm.dateRange && that.searchForm.dateRange.length > 0) {
                param.beginTime = that.searchForm.dateRange[0];
                param.endTime = that.searchForm.dateRange[1];
            }
            
            that.$axios.post(that.$store.state.platformApi + "exchange/coupon/page", JSON.stringify(param)).then(result => {
                if (result.code == 200) {
                    that.couponList = result.data.records;
                    that.manageTotal = result.data.total;
                }
            });
        },
        // 获取统计列表
        getStatsList() {
            let that = this;
            let param = {
                type: that.statsForm.type
            };
            that.$axios.post(that.$store.state.platformApi + "exchange/coupon/statistics", JSON.stringify(param)).then(result => {
                if (result.code == 200) {
                    that.statsList = result.data;
                    that.statsTotal = result.data.length;
                }
            });
        },
        // 管理页面分页
        handleManageSizeChange(val) {
            this.managePageSize = val;
            this.getCouponList();
        },
        handleManageCurrentChange(val) {
            this.manageCurrentPage = val;
            this.getCouponList();
        },
        // 统计页面分页
        handleStatsSizeChange(val) {
            this.statsPageSize = val;
            this.getStatsList();
        },
        handleStatsCurrentChange(val) {
            this.statsCurrentPage = val;
            this.getStatsList();
        },
        filterCouponType(type){
            switch(type){
                case 3:
                    return '美式咖啡兑换券';
                case 4:
                    return '冰美式咖啡兑换券';
                case 5:
                    return '拿铁兑换券';
                case 6:
                    return '卡布奇诺兑换券';
                case 7:
                    return '摩卡兑换券';
                case 8:
                    return '无糖巧克力兑换券';
                case 9:
                    return '无糖巧克力牛奶兑换券';
                case 10:
                    return '热牛奶兑换券';
                default:
                    return '其他';
            }
        }
    }
};
</script>

<style lang="scss" scoped>
</style>